module.exports = __webpack_public_path__ + "img/video7.c4b72a6e.jpg";